module.exports = __webpack_public_path__ + "media/images/convenios/cons_prof_economica-dc026ed6a42eadf52947ffca7a04174a.png";